import { render, staticRenderFns } from "./OctCard.vue?vue&type=template&id=b9d40416&scoped=true&"
import script from "./OctCard.vue?vue&type=script&lang=js&"
export * from "./OctCard.vue?vue&type=script&lang=js&"
import style0 from "./OctCard.vue?vue&type=style&index=0&id=b9d40416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d40416",
  null
  
)

export default component.exports